var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.001C32 14.0439 31.648 12.1691 31.0048 10.4359L16 9.74017L0.995188 10.4358C0.352063 12.1691 0 14.0439 0 16.001C0 17.9582 0.352063 19.833 0.995188 21.5662L16 22.2619L31.0048 21.5663C31.648 19.833 32 17.9582 32 16.001Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 32.001C22.8796 32.001 28.7443 27.659 31.005 21.5662H0.995361C3.25605 27.659 9.12074 32.001 16.0002 32.001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995361 10.4358H31.005C28.7443 4.34298 22.8796 0.000976562 16.0002 0.000976562C9.12074 0.000976562 3.25605 4.34298 0.995361 10.4358V10.4358Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/BG.92730f40.svg";
export { ForwardRef as ReactComponent };